import React from "react";
import exportCSV from "../../utils/CSV";
import exportExcel from "../../utils/Excel";
import { showToast } from "../../utils/Toastify/Toastify";
import styles from "./AnalyticsDashboard.module.css";

// Exports the rows the calling section currently has loaded -- already
// scoped to whatever date range/platform/content-type filters are active.
// For a paginated section, pass `fetchRows` (an async () => rows[] that
// re-queries with the current filters but no page limit) so the export
// covers every matching row instead of just the page on screen; `rows` is
// still used as-is for sections with no pagination.
const ExportButtons = ({ rows, fetchRows, filename, className }) => {
  const handle = async (fn, ext) => {
    let data = rows;
    if (fetchRows) {
      try {
        data = await fetchRows();
      } catch (err) {
        showToast("Failed to prepare export", "error");
        return;
      }
    }
    if (!data || !data.length) {
      showToast("No data to export for the current filters", "error");
      return;
    }
    fn(data, `${filename}.${ext}`);
  };

  return (
    <div className={`${styles.exportGroup} ${className || ""}`.trim()}>
      <button type="button" className={styles.preset} onClick={() => handle(exportCSV, "csv")}>
        Export CSV
      </button>
      <button type="button" className={styles.preset} onClick={() => handle(exportExcel, "xlsx")}>
        Export Excel
      </button>
      <button type="button" className={styles.preset} onClick={() => window.print()}>
        Print / PDF
      </button>
    </div>
  );
};

export default ExportButtons;
